module.exports = __webpack_public_path__ + "static/media/sun-placeholder.c765203c.svg";